"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7276],{

/***/ 11745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var src_components_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62414);
/* harmony import */ var src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37398);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






const FilterTag = _ref => {
  let {
    item,
    groupKey,
    hasCloseButton,
    onClick
  } = _ref;
  const isHidden = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_3__/* .filterIsHidden */ .ai)(item, groupKey));

  if (isHidden) {
    return null;
  }

  const isSelected = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_3__/* .filterIsSelected */ .$W)(item, groupKey));
  const label = hasCloseButton && item.label && item.label !== '' ? item.label : item.name;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(src_components_common__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    isSelected: isSelected,
    onClick: onClick,
    hasCloseButton: hasCloseButton,
    label: label
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTag);

/***/ }),

/***/ 97276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18132);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14416);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(75159);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47741);
/* harmony import */ var src_redux_nlt_offer_actions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26869);
/* harmony import */ var src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37398);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11745);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_output_src1686024941_src_mr_planner_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












const SuggestedFilters = _ref => {
  let {
    colSpan
  } = _ref;
  const {
    t
  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)();
  const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
  const allFilters = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_5__/* .filters */ .u8);
  const selectedFilters = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_5__/* .selectedFilters */ .L$);
  const suggestedFilters = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(state => state.nlt.suggestedFilters);

  const toggleFilterHandler = (filter, groupKey) => dispatch((0,src_redux_nlt_offer_actions__WEBPACK_IMPORTED_MODULE_6__/* .toggleFilter */ .cT)(filter.value, groupKey));

  const resetFiltersHandler = () => dispatch((0,src_redux_nlt_offer_actions__WEBPACK_IMPORTED_MODULE_6__/* .resetAllFilters */ ._4)());

  const {
    0: isMounted,
    1: setMount
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  let selectedFiltersExceptSuggested = [];
  selectedFilters.forEach(selectedFilter => {
    suggestedFilters.forEach(suggestedFilter => {
      let items = [];
      let selectedFiltersExceptSuggestedItem = {
        key: selectedFilter.key,
        items
      };

      if (selectedFilter.key === suggestedFilter.key) {
        selectedFilter.items.forEach(selectedItem => {
          if (!suggestedFilter.items.length || !suggestedFilter.items.some(suggestedItem => suggestedItem.name === selectedItem.name)) {
            const selectedCompleteItem = (0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_5__/* .getFilterByGroupAndValue */ .jN)(allFilters, selectedFilter.key, selectedItem.value);

            if (selectedCompleteItem) {
              selectedFiltersExceptSuggestedItem.items.push(selectedCompleteItem);
            }
          }
        });
      } else {
        selectedFiltersExceptSuggestedItem.items = selectedFilter.items.map(filterItem => {
          const validatedFilterItem = (0,src_redux_nlt_offer_selectors__WEBPACK_IMPORTED_MODULE_5__/* .getFilterByGroupAndValue */ .jN)(allFilters, selectedFilter.key, filterItem.value);

          if (validatedFilterItem) {
            return _objectSpread({}, validatedFilterItem);
          }

          return null;
        }).filter(filterItem => filterItem !== null);
      }

      selectedFiltersExceptSuggested.push(selectedFiltersExceptSuggestedItem);
    });
  });
  const displayResetFilters = selectedFilters.flatMap(selectedFilter => selectedFilter.items).length > 0;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .GridItem */ .P4, {
    display: {
      base: 'none',
      sm: 'block'
    },
    colSpan: colSpan,
    mt: "-2",
    textAlign: "left",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .xv, {
      fontFamily: "Montserrat-SemiBold",
      fontWeight: "bold",
      fontSize: src_themes__WEBPACK_IMPORTED_MODULE_8__/* .theme.space.s */ .r.space.s,
      color: "baseNeutral.700",
      children: t('offersListContainer:suggestedFilters')
    }), suggestedFilters.map(filterGroup => filterGroup.items.map(item => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(___WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      item: item,
      groupKey: filterGroup.key,
      onClick: () => toggleFilterHandler(item, filterGroup.key)
    }, `suggested-${item.name}-${item.value}`))), selectedFiltersExceptSuggested.map(filterGroup => filterGroup.items.map(item => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(___WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      item: item,
      groupKey: filterGroup.key,
      onClick: () => toggleFilterHandler(item, filterGroup.key),
      hasCloseButton: true
    }, `filtered-${item.name}-${item.value}`))), displayResetFilters && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .zx, {
      onClick: resetFiltersHandler,
      color: "baseDark",
      variant: "link",
      fontFamily: "Montserrat-Medium",
      fontWeight: "normal",
      ml: "m",
      children: t('offersListContainer:resetFilters')
    })]
  }, "filtri-suggeriti");
};

/* harmony default export */ __webpack_exports__["default"] = (SuggestedFilters);

/***/ }),

/***/ 62414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47741);
/* harmony import */ var _chakra_ui_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3382);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75159);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);






const FilterTag = _ref => {
  let {
    isSelected,
    hasCloseButton,
    label,
    onClick
  } = _ref;
  const {
    0: isMounted,
    1: setMount
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setMount(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  const bgColor = isSelected ? src_themes__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.primaryGreen[300] */ .r.colors.primaryGreen[300] : 'white';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
    color: src_themes__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.primaryGreen[900] */ .r.colors.primaryGreen[900],
    variant: "outline",
    fontFamily: "Montserrat-Medium",
    fontWeight: "normal",
    size: "xs",
    h: "32px",
    mr: 1,
    my: 1,
    borderRadius: 4,
    bg: bgColor,
    _hover: {
      backgroundColor: bgColor
    },
    borderColor: src_themes__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.primaryGreen[300] */ .r.colors.primaryGreen[300],
    userSelect: "none",
    onClick: onClick,
    rightIcon: hasCloseButton ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_icons__WEBPACK_IMPORTED_MODULE_4__/* .CloseIcon */ .Tw, {
      boxSize: "0.7rem"
    }) : undefined,
    children: label
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FilterTag);

/***/ })

}]);